/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddTagsToShipmentsRequest {
  shipment_ids?: string[];
  tag_ids?: string[];
}

export interface Addon {
  code?: string;
  data?: Record<string, string>;
  name?: string;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface Contents {
  external_orders?: ExternalOrderContentItem[];
  goods?: LineItem[];
  transport_orders?: TransportOrderContentItem[];
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface CreateShipmentActionRequest {
  action?: string;
  shipment_id?: string;
}

export interface CreateShipmentTemplateRequest {
  tag_ids?: string[];
  template?: ShipmentData;
}

export interface CreateShipmentTemplateResponse {
  tags?: Tag[];
  template?: ShipmentTemplate;
}

export interface CreateTagRequest {
  name?: string;
}

export interface CreateTagResponse {
  tag?: Tag;
}

export interface CustomerInfo {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  email?: string;
  phone?: string;
}

export interface Dimensions {
  /** @format uint64 */
  height?: number;
  /** @format uint64 */
  length?: number;
  /** @format uint64 */
  width?: number;
}

export interface ExternalOrderContentItem {
  external_id?: string;
}

export interface GetShipmentTemplateResponse {
  tags?: Tag[];
  template?: ShipmentTemplate;
}

export interface GetShipmentsByTagsResponse {
  tagged_shipments?: TaggedShipments[];
}

export interface GetUserShipmentsResponse {
  shipment_ids?: string[];
}

export interface LineItem {
  currency?: string;
  description?: string;
  dimensions?: Dimensions;
  name?: string;
  /** @format uint64 */
  price?: number;
  /** @format uint64 */
  quantity?: number;
  sku?: string;
  tags?: string[];
  /** @format uint64 */
  weight?: number;
}

export interface ListShipmentTemplatesResponse {
  shipment_templates_with_tags?: ShipmentTemplateWithTags[];
}

export interface ListTagsResponse {
  tags?: Tag[];
}

/** ParcelDetails contains additional information about parcels. */
export interface ParcelDetails {
  /** Parcel contents */
  contents?: Contents;
  /** Parcel dimensions */
  dimensions?: Dimensions;
  label_free_text?: string;
  /**
   * Weight in grams
   * @format uint64
   */
  weight?: number;
}

export interface RenameTagResponse {
  tag?: Tag;
}

export interface ShipmentData {
  addons?: Addon[];
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address_from?: Address;
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address_return?: Address;
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address_to?: Address;
  /** Contents */
  contents?: Contents;
  courier_instructions?: string;
  customer_info?: CustomerInfo;
  dimensions?: Dimensions;
  meta?: Record<string, string>;
  /** Consignment details */
  name?: string;
  /** @format uint64 */
  number_of_parcels?: number;
  /** Parcels */
  parcels?: ParcelDetails[];
  /**
   * Shipment options
   * @format uint64
   */
  shipment_value?: number;
  shipping_method?: string;
  /** @format uint64 */
  weight?: number;
}

export interface ShipmentTemplate {
  data?: ShipmentData;
  id?: string;
}

export interface ShipmentTemplateWithTags {
  tags?: Tag[];
  template?: ShipmentTemplate;
}

export interface Status {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

export interface Tag {
  id?: string;
  name?: string;
  /** UserID is set for "personal tags". It is id of the user, to whom this tag is attached. */
  user_id?: string;
}

export interface TaggedShipments {
  shipment_ids?: string[];
  tag?: Tag;
}

export interface TransportOrderContentItem {
  external_ref?: string;
  tos_id?: string;
}

export interface UpdateShipmentTemplateForSiteRequest {
  tag_ids?: string[];
  template?: ShipmentTemplate;
}

export interface UpdateShipmentTemplateRequest {
  tag_ids?: string[];
  template?: ShipmentTemplate;
}

export interface UpdateShipmentTemplateResponse {
  tags?: Tag[];
  template?: ShipmentTemplate;
}

export interface UpdateUserTagsRequest {
  tag_ids?: string[];
  user_id?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/userprofile" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title UserProfile API
 * @version 1.0
 * @baseUrl /v1/userprofile
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  shipmentActionsCreate = {
    /**
     * No description
     *
     * @name UserProfileCreateShipmentAction
     * @request POST:/shipment_actions.create
     * @secure
     */
    userProfileCreateShipmentAction: (body: CreateShipmentActionRequest, params: RequestParams = {}) =>
      this.request<object, Status>({
        path: `/shipment_actions.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentActionsGetShipments = {
    /**
     * No description
     *
     * @name UserProfileGetUserShipments
     * @request GET:/shipment_actions.get_shipments
     * @secure
     */
    userProfileGetUserShipments: (params: RequestParams = {}) =>
      this.request<GetUserShipmentsResponse, Status>({
        path: `/shipment_actions.get_shipments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentTemplatesCreate = {
    /**
     * No description
     *
     * @name UserProfileCreateShipmentTemplate
     * @request POST:/shipment_templates.create
     * @secure
     */
    userProfileCreateShipmentTemplate: (body: CreateShipmentTemplateRequest, params: RequestParams = {}) =>
      this.request<CreateShipmentTemplateResponse, Status>({
        path: `/shipment_templates.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentTemplatesDelete = {
    /**
     * No description
     *
     * @name UserProfileDeleteShipmentTemplate
     * @request DELETE:/shipment_templates.delete
     * @secure
     */
    userProfileDeleteShipmentTemplate: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, Status>({
        path: `/shipment_templates.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentTemplatesGet = {
    /**
     * No description
     *
     * @name UserProfileGetShipmentTemplate
     * @request GET:/shipment_templates.get
     * @secure
     */
    userProfileGetShipmentTemplate: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShipmentTemplateResponse, Status>({
        path: `/shipment_templates.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentTemplatesList = {
    /**
     * No description
     *
     * @name UserProfileListShipmentTemplates
     * @request GET:/shipment_templates.list
     * @secure
     */
    userProfileListShipmentTemplates: (
      query?: {
        tag_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListShipmentTemplatesResponse, Status>({
        path: `/shipment_templates.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentTemplatesUpdate = {
    /**
     * No description
     *
     * @name UserProfileUpdateShipmentTemplate
     * @request POST:/shipment_templates.update
     * @secure
     */
    userProfileUpdateShipmentTemplate: (body: UpdateShipmentTemplateRequest, params: RequestParams = {}) =>
      this.request<UpdateShipmentTemplateResponse, Status>({
        path: `/shipment_templates.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sites = {
    /**
     * No description
     *
     * @name UserProfileDeleteShipmentTemplateForSite
     * @request DELETE:/sites/shipment_templates.delete
     * @secure
     */
    userProfileDeleteShipmentTemplateForSite: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, Status>({
        path: `/sites/shipment_templates.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserProfileGetShipmentTemplateForSite
     * @request GET:/sites/shipment_templates.get
     * @secure
     */
    userProfileGetShipmentTemplateForSite: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShipmentTemplateResponse, Status>({
        path: `/sites/shipment_templates.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserProfileListShipmentTemplatesForSite
     * @request GET:/sites/shipment_templates.list
     * @secure
     */
    userProfileListShipmentTemplatesForSite: (
      query?: {
        tag_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListShipmentTemplatesResponse, Status>({
        path: `/sites/shipment_templates.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserProfileUpdateShipmentTemplateForSite
     * @request POST:/sites/shipment_templates.update
     * @secure
     */
    userProfileUpdateShipmentTemplateForSite: (
      body: UpdateShipmentTemplateForSiteRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateShipmentTemplateResponse, Status>({
        path: `/sites/shipment_templates.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tagsCreate = {
    /**
     * No description
     *
     * @name UserProfileCreateTag
     * @request POST:/tags.create
     * @secure
     */
    userProfileCreateTag: (body: CreateTagRequest, params: RequestParams = {}) =>
      this.request<CreateTagResponse, Status>({
        path: `/tags.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tagsDelete = {
    /**
     * No description
     *
     * @name UserProfileDeleteTags
     * @request DELETE:/tags.delete
     * @secure
     */
    userProfileDeleteTags: (
      query?: {
        ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<object, Status>({
        path: `/tags.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsGetShipments = {
    /**
     * No description
     *
     * @name UserProfileGetShipmentsByTags
     * @request GET:/tags.getShipments
     * @secure
     */
    userProfileGetShipmentsByTags: (
      query?: {
        tag_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShipmentsByTagsResponse, Status>({
        path: `/tags.getShipments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsList = {
    /**
     * No description
     *
     * @name UserProfileListTags
     * @request GET:/tags.list
     * @secure
     */
    userProfileListTags: (
      query?: {
        user_id?: string;
        template_id?: string;
        shipment_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTagsResponse, Status>({
        path: `/tags.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsRemoveFromShipment = {
    /**
     * No description
     *
     * @name UserProfileRemoveTagFromShipments
     * @request DELETE:/tags.removeFromShipment
     * @secure
     */
    userProfileRemoveTagFromShipments: (
      query?: {
        tag_id?: string;
        shipment_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<object, Status>({
        path: `/tags.removeFromShipment`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsRename = {
    /**
     * No description
     *
     * @name UserProfileRenameTag
     * @request PUT:/tags.rename
     * @secure
     */
    userProfileRenameTag: (
      query?: {
        id?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RenameTagResponse, Status>({
        path: `/tags.rename`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagsTagShipments = {
    /**
     * No description
     *
     * @name UserProfileAddTagsToShipments
     * @request POST:/tags.tagShipments
     * @secure
     */
    userProfileAddTagsToShipments: (body: AddTagsToShipmentsRequest, params: RequestParams = {}) =>
      this.request<object, Status>({
        path: `/tags.tagShipments`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userTagsList = {
    /**
     * No description
     *
     * @name UserProfileListUserTags
     * @request GET:/user_tags.list
     * @secure
     */
    userProfileListUserTags: (params: RequestParams = {}) =>
      this.request<ListTagsResponse, Status>({
        path: `/user_tags.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  userTagsUpdate = {
    /**
     * No description
     *
     * @name UserProfileUpdateUserTags
     * @request POST:/user_tags.update
     * @secure
     */
    userProfileUpdateUserTags: (body: UpdateUserTagsRequest, params: RequestParams = {}) =>
      this.request<object, Status>({
        path: `/user_tags.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
